import { useRef, useState } from "react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface TruncatedCellProps {
  content: string | null | undefined;
  className?: string;
}

export const TruncatedCell = ({ content, className }: TruncatedCellProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    if (ref.current) {
      setOpen(ref.current.scrollWidth > ref.current.clientWidth);
    }
  };

  const text = content ?? '';

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <span
          ref={ref}
          onMouseEnter={handleMouseEnter}
          className={cn("block truncate min-w-0", className)}
        >
          {text}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs break-words">
        {text}
      </TooltipContent>
    </Tooltip>
  );
};
